import Papa from 'papaparse';

export interface ParseResult {
	headers: string[];
	data: Record<string, string>[];
}

export const parseCsvFile = (file: File): Promise<ParseResult> =>
	new Promise((resolve, reject) => {
		Papa.parse(file, {
			header: true,
			skipEmptyLines: true,
			complete: (results) => {
				const headers = results.meta.fields || [];
				const data = results.data as Record<string, string>[];
				resolve({ headers, data });
			},
			error: (err) => {
				reject(err.message);
			},
		});
	});
